<template>
  <div>
    <a-modal
      :destroyOnClose="true"
      :visible="visible"
      :title="isUpdateMode ? '修改产品大类' : '创建产品大类'"
      width="50%"
      centered
      okText="确认"
      cancelText="取消"
      @ok="() => onSubmit()"
      @cancel="() => hideDialog()"
    >
      <a-form-model layout="vertical" :rules="rules" :model="form" ref="form">
        <a-form-model-item label="产品大类名称" prop="name">
          <a-input width="100%" v-model="form.name" placeholder="请输入产品大类名称"> </a-input>
        </a-form-model-item>
        <a-form-model-item v-if="productCategories.length" label="产品目录" prop="productCategoryId">
          <a-select
            v-model="form.productCategoryId"
            allowClear
            placeholder="请选择产品目录"
            showSearch
            optionFilterProp="label"
          >
            <a-select-option
              v-for="(productCategorie, key) in productCategories"
              :key="key"
              :label="productCategorie.name"
              :value="productCategorie.id"
              >{{ productCategorie.name }}</a-select-option
            >
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="概念图" prop="conceptImages">
          <div class="clearfix">
            <a-upload
              list-type="picture-card"
              accept="image/*"
              :customRequest="conceptCustomRequest"
              :file-list="conceptImages"
              @preview="handlePreview"
              :remove="removeConceptImages"
            >
              <div>
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </div>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <upload-progress ref="uploadProgress" />
  </div>
</template>

<script>
import clonedeep from 'lodash.clonedeep';
import UploadProgress from '../../../../components/upload-progress/UploadProgress';

export default {
  name: 'ProductClassesFormModal',
  components: { UploadProgress },
  mounted() {},
  data() {
    return {
      loadedDeviceTypeList: undefined,
      previewVisible: false,
      previewImage: '',
      conceptImages: [],
      rules: {
        name: [{ required: true, message: '产品大类名称 不能为空', trigger: 'blur' }],
        productCategoryId: [{ required: true, message: '产品目录 不能为空', trigger: 'blur' }],
      },
      visible: false,
      isUpdateMode: false,
      resultCallBack: {
        onSubmit: Function,
      },
      productCategories: [],
      form: {
        name: undefined,
      },
    };
  },
  methods: {
    cancel() {
      this.$router.back();
    },
    hideDialog() {
      this.visible = false;
      this.conceptImages = [];
      this.form = {
        name: undefined,
      };
    },
    showCreateDialog(pararms, treeData, callback) {
      this.form = clonedeep(pararms);
      this.productCategories = treeData;
      this.isUpdateMode = false;
      this.resultCallBack.onSubmit = callback;
      this.conceptImages = [];
      this.visible = true;
    },
    showUpdateDialog(pararms, treeData, callback) {
      this.isUpdateMode = true;
      this.productCategories = treeData;
      this.form = clonedeep(pararms);
      this.resultCallBack.onSubmit = callback;
      this.initConceptImages();
      this.visible = true;
    },
    initConceptImages() {
      this.conceptImages = [];
      const urls = this.form.conceptImageDownloadUrls || [];
      const paths = this.form.conceptImages || [];
      urls.forEach((url, index) => {
        const image = {
          url,
          filePath: paths[index],
          name: paths[index],
          uid: -index,
        };
        this.conceptImages.push(image);
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },
    async handlePreview(file) {
      const imageFile = file;
      if (!imageFile.url && !imageFile.preview) {
        imageFile.preview = await this.getBase64(imageFile.originFileObj);
      }
      this.previewImage = imageFile.url || imageFile.preview;
      this.previewVisible = true;
    },
    async conceptCustomRequest(request) {
      this.$refs.uploadProgress.visible = true;
      const fileUploadResponse = await this.$apiManager.file.uploadFile(
        this.$constRepository.file.Module.productClass,
        this.$constRepository.file.Submodule.conceptImages,
        request.file,
      );
      this.$refs.uploadProgress.visible = false;
      this.$store.commit('setUploadProgress', -1);
      if (fileUploadResponse.data.filePath) {
        const reader = new FileReader();
        reader.readAsDataURL(request.file);
        const params = {
          filePath: fileUploadResponse.data.filePath,
          uid: request.file.uid,
          status: 'done',
          name: request.file.name,
        };
        reader.onloadend = (e) => {
          const url = e.target.result;
          params.url = url;
          this.conceptImages.push(params);
        };
      }
    },
    removeConceptImages(record) {
      this.conceptImages = this.conceptImages.filter((image) => image !== record);
    },
    onSubmit() {
      this.form.conceptImages = this.conceptImages.map((image) => image.filePath);
      this.$refs.form.validate((relsValid) => {
        if (relsValid) {
          this.resultCallBack.onSubmit(this.form);
          this.hideDialog();
        } else {
          this.$message.warn('基础信息存在未填写的数据');
        }
      });
    },
  },
};
</script>
